var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"surf-embed-wrap"},[_c('div',{staticClass:"surf-embed-inner",style:(_vm.innerStyles)},[_c('iframe',{staticClass:"surf-embed",attrs:{"src":_vm.embedUrl,"allowfullscreen":"yes","scrolling":"yes"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }